import css from "../styles/ImpersonationBanner.module.css";

const ImpersonationBanner = () => {
  return (
    <div className={css["header-row"]}>
      <div className={css["promotion"]}>NOTE: Impersonate by admin user.</div>
    </div>
  );
};

export default ImpersonationBanner;
